module.exports = __webpack_public_path__ + "img/left_bottom_1.9333882.png";